import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData, CurrentProductService } from '@spartacus/storefront';
import { combineLatest, filter, map, Observable, of, switchMap, take, tap, withLatestFrom } from 'rxjs';
import {
  CmsProductReferencesComponent,
  isNotNullable,
  Product,
  ProductReference,
  ProductReferenceService,
  ProductService,
} from '@spartacus/core';
import { ToolsService } from '../../../../../../../core/services/tools.service';
import { CustomProductCarouselComponent } from '../product-carousel/product-carousel.component';
import { ProductAuxService } from '../../../../../product/_core/product-aux.service';

@Component({
  selector: 'cx-product-references',
  templateUrl: '../product-carousel/product-carousel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomProductReferencesComponent extends CustomProductCarouselComponent implements OnInit {
  protected get productCode$(): Observable<string> {
    return this._currentProductService.getProduct().pipe(
      filter(isNotNullable),
      map(product => product.code ?? ''),
      tap(() => this.productReferenceService.cleanReferences()),
    );
  }

  constructor(
    private cmsComponentData: CmsComponentData<CmsProductReferencesComponent>,
    private _currentProductService: CurrentProductService,
    private productReferenceService: ProductReferenceService,
    private _productAuxService: ProductAuxService,
    private __componentData: CmsComponentData<any>,
    private __productService: ProductService,
    private _toolsService: ToolsService,
  ) {
    super(__componentData, __productService, _toolsService, _productAuxService, _currentProductService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override getItems(): void {
    this.subscription.add(
      this.productCode$
        .pipe(
          take(1),
          withLatestFrom(this.cmsComponentData.data$.pipe(filter(data => Boolean(data)))),
          tap(([productCode, data]) =>
            this.productReferenceService.loadProductReferences(productCode, data.productReferenceTypes),
          ),
          switchMap(([productCode, data]) => this.getProductReferences(productCode, data.productReferenceTypes ?? '')),
          switchMap(items => combineLatest(items)),
          map(items => items.filter(item => isNotNullable(item))),
          filter(items => items.length > 0),
        )
        .subscribe(products => {
          this.setProducts(products);
        }),
    );
  }

  getProductReferences(code: string, referenceType: string): Observable<Observable<Product | undefined>[]> {
    return this.productReferenceService.getProductReferences(code, referenceType).pipe(
      filter(references => Boolean(references)),
      map((references: ProductReference[]) => [...references].map(reference => of(reference.target))),
    );
  }
}
